import React from 'react';
import {Table, TableHead, TableRow, TableCell, TableBody, styled, Box} from '@mui/material';
import PropTypes from 'prop-types';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';

const UpSellRecommendationDetail = (props: { levelFourData: any; dataToBeSave: any, selectedL4Value: any, 
  customerId: any, setAdjustPoistionIconValue: any, resettingValueWithIncludeBitForUpSell: any}) => {
const {levelFourData, dataToBeSave, selectedL4Value, customerId, setAdjustPoistionIconValue, resettingValueWithIncludeBitForUpSell} = props;

  const StyledTableCellData = styled(TableCell)({
    backgroundColor: 'black',
    color: 'white',
    borderRight: '0.1px solid rgb(51, 50, 49)',
    borderBottom: '0.1px solid rgb(51, 50, 49)' ,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '0.63vw',
    fontFamily: 'BlinkMacSystemFont,-apple-system,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","Helvetica","Arial",sans-serif;',
    height: '57.34px', 
    padding:0, paddingLeft:'2px !important', paddingRight:'2px !important', paddingTop:'2px !important', paddingBottom:'2px !important'     
 
})

const StyledCircularBar = styled(CircularProgressbar)({
  width : '28%'
})

const handleInclude = (event: any, d: any, index: any) => {
  let ischecked = event.target.checked === true ? 1 : 0;

  if (ischecked !== d.IsIncluded) {
    let objToBeAdded =  {
      l4: selectedL4Value,
      itemNo: d.ItemNo,
      include: ischecked,
      customer: customerId
    };

    dataToBeSave(objToBeAdded);    
  }

  resettingValueWithIncludeBitForUpSell(event, index);
}

const numberFormatter = (num : any) => {
  if(num > 999 && num < 1000000){
      return (num/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
  }else if(num > 1000000){
      return (num/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
  }else if(num < 900){
      return num; // if value < 1000, nothing to do
  }
}

  return (
    <>
    {levelFourData?.data?.length === 0 ?
        (<Table>
            <TableBody>
              <TableRow style={{ border:'0.2px solid rgb(117, 189, 8)', height: document.getElementById('recommendationData')?.clientHeight}}>
                <span className="divTextCenter" style={{marginTop: '60px'}}>No recommended items to show</span>	 
              </TableRow>
            </TableBody>
        </Table>) :  
        levelFourData ?  (
      <Box>
        <Table stickyHeader style={{background: 'none', color: '#ffffff', border:'0.2px solid rgb(117, 189, 8)'}} >
        <TableHead>
            <TableRow > 
                <StyledTableCellData colSpan={8} className="alignCenter" style={{borderBottom: '0.2px solid rgb(117, 189, 8)', height: '27.34px'}}>
                  Recommended Items (click L4 to get list of suggested upsell items)
                </StyledTableCellData>
            </TableRow>
          <TableRow>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>
              Item No.
            </StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Description</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Brand</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Revenue ($)</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Margin ($)</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Sold to similar customers</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Adoption % (likelihood)</StyledTableCellData>
            <StyledTableCellData style={{ borderBottom: '0.2px solid rgb(117, 189, 8)'}}>Include in list ?</StyledTableCellData>
          </TableRow>
        </TableHead>
        <TableBody>
        {levelFourData?.data?.map((headCell: any, index: any) => (
                <TableRow>
                <StyledTableCellData style={{ borderRight: '0.1px solid rgb(51, 50, 49) !important',}}>{headCell.ItemNo}</StyledTableCellData>
                <StyledTableCellData>{headCell.desc}</StyledTableCellData>
                <StyledTableCellData>{headCell.brand}</StyledTableCellData>
                <StyledTableCellData>${numberFormatter(Math.round(headCell.Revenue))}</StyledTableCellData>
                <StyledTableCellData>${numberFormatter(Math.round(headCell.Margin))}</StyledTableCellData>
                <StyledTableCellData>{headCell.SoldToSimilarCust *100}%</StyledTableCellData>
                <StyledTableCellData className="alignCenter cursorPointer bg">
                  <StyledCircularBar value={headCell.AdoptionPercentage *100} className="circleWidth"  strokeWidth={50}
                    styles={buildStyles({strokeLinecap: "butt", backgroundColor: "white", pathColor: "grey", })} />
                  </StyledTableCellData>
                <StyledTableCellData>
                  <input type='checkbox' className="alignCenter" defaultChecked={headCell.IsIncluded === 1 
                    ? true : false} onClick = {() => handleInclude(event, headCell, index)}/>
                </StyledTableCellData>
              </TableRow>              
            ))}
        </TableBody>
        </Table>
      </Box>
    ) :  (
      <Box>
        <Table>
          <TableBody>
            <TableRow style={{ border:'0.2px solid rgb(117, 189, 8)', height: document.getElementById('recommendationData')?.clientHeight}}>
              <span  className="divTextCenter"  style={{marginTop: '60px'}}>click L4 to get list of suggested upsell items</span>	  
            </TableRow>
          </TableBody>
        </Table> 
			</Box>)
    }
    </>     
    )
}

UpSellRecommendationDetail.propTypes = {
	levelFourData: PropTypes.objectOf(PropTypes.object),
  dataToBeSave: PropTypes.func,
  selectedL4Value: PropTypes.string,
  customerId: PropTypes.string,
  setAdjustPoistionIconValue: PropTypes.func,
};

export default UpSellRecommendationDetail;
